import buildUrl from './buildUrl'
import download from './downloadFile'

export default function downErrFile(params) {
    // download(buildUrl('/templeteConfig/getTemplete'), params, '毕业名单模板.xlsx')
    download(buildUrl('/leavingschool/graduationStudent/downStudentError'), params, '错误数据模板.xlsx')
    // window.location.href = buildUrl('/templeteConfig/getTemplete?')+params2link(params)
}